export default __webpack_public_path__ + "c75563ac40b6f9ace482d04775e0852c.png";